import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const CAMPAIGN_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.CAMPAIGN]}`;
export const CAMPAIGN_ID_PARAM_NAME = 'campaignId';
export const CAMPAIGN_ID_PARAM_TEMPLATE = `/:${CAMPAIGN_ID_PARAM_NAME}?`;
